import { render, staticRenderFns } from "./AdminStandaloneOrderModal.vue?vue&type=template&id=7a63f882&scoped=true"
import script from "./AdminStandaloneOrderModal.vue?vue&type=script&lang=js"
export * from "./AdminStandaloneOrderModal.vue?vue&type=script&lang=js"
import style0 from "./AdminStandaloneOrderModal.vue?vue&type=style&index=0&id=7a63f882&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63f882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a63f882')) {
      api.createRecord('7a63f882', component.options)
    } else {
      api.reload('7a63f882', component.options)
    }
    module.hot.accept("./AdminStandaloneOrderModal.vue?vue&type=template&id=7a63f882&scoped=true", function () {
      api.rerender('7a63f882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/StandaloneOrders/AdminStandaloneOrderModal.vue"
export default component.exports